export default __webpack_public_path__ + "hero-next-992-2e3ff6b1f05b4b89be30ab7da856ed1c.bundle.png";